<template>
  <b-row class="options-main no-gutters border-classh">
    <b-col class="reduce-padding" cols="12">
      <b-row class="border no-gutters">
        <b-col class="reduce-padding" cols="12">
          <div class="header-area">
            TED Triggers and Flares
          </div>
        </b-col>
        <!--body-->
        <b-col class="reduce-padding" cols="12">
          <div class="body-area" md="6">
            <b-row class=" no-gutters">
              <b-col class="reduce-padding top-margin" cols="12" md="6">

                <div class="left-col">

                  <p class="TED-text">Learn what TED symptoms to look out for:</p>

                  <div class="button-div"><a @click="tagNav('TED Symptoms Button','pre-launch-options')" href="https://www.thyroideyes.com/thyroid-eye-disease-symptoms/" target="_blank"><button class="ted-button">TED SYMPTOMS</button></a> </div>
                </div>
                <hr class="horizontal-line sm-screen lg-screen">
                <div class="v1">
                  <div class="vertical-line"></div>
                </div>
              </b-col>
              <b-col class="reduce-padding top-margin" cols="12" md="6">
                <div class="right-col">
                  <p class="TED-text">Continue with the TED Triggers and Flares tool:</p>
                  <div class="button-div">
                    <router-link :to="{path: '/getStarted'}" exact><button @click="tagNav('Continue Button','pre-launch-options')" class="ted-button">CONTINUE</button></router-link>
                  </div>
                </div>
              </b-col>

              <div class="footer">
                <p class="footer-text">* This tool is not meant to provide medical advice and is for general educational purposes only.</p>
              </div>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>


<script>
/* eslint-disable */
import scrollMixin from "../mixins/scrollMixin";
import taggingMixin from "../mixins/taggingMixin";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "optionsMain",
  mixins: [scrollMixin, taggingMixin],
  mounted: function () {
    this.scrollToTop();
    var url = window.location.href;
     var obj={ 
    'hitType': 'pageview', 
    'page': '/pre-launch-options', 
    'title': 'pre-launch-options' , 
    'location': url.replace(/#.*$/, '')+'#/'+'pre-launch-options'
    };
    try {
      console.log("sending Message:", JSON.stringify(obj));
      window.top.postMessage(JSON.stringify(obj), "*");
    } catch(e) {
      console.log("error sending Message");
    }
  },
  components: {},

  data() {
    return {};
  },
  computed: {
    ...mapGetters("userData", ["userData"]),
  },

  methods: {
    ...mapMutations("userData"),
    start: function () {},
  },
};
</script>

<style lang="scss" scoped>
</style>
